import React, { useEffect, useState } from 'react';

const InstagramPostPreview = ({ igUrl }) => {
  const [embeddedIgUrl, setEmbeddedIgUrl] = useState("");

  useEffect(() => {
    if (igUrl) { setEmbeddedIgUrl(igUrl[igUrl.length - 1] === '/' ? `${igUrl}embed/` : `${igUrl}/embed/`); }
  }, [igUrl]);

  return (
      <div className="ig-post-preview">
        <iframe
          id={igUrl}
          title="Instagram post preview"
          src={embeddedIgUrl}
          height="300"
          width="100%"
          style={{ border: 'none', overflow: 'hidden' }}
          allowFullScreen
        />
      </div>
  );
};

export default InstagramPostPreview;
